import { client } from "../client/client";

export const fetchMemberGrowthRate = async (params = {}) => {
  try {
    const response = await client.get(
      "/api/v1/report/analytics/member-growth-rate",
      { params },
    );
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchMemberReportAnalytics = async (params = {}) => {
  try {
    const response = await client.get(
      "/api/v1/report/analytics/member-report",
      { params },
    );
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchSavingsDepositsAnalytics = async (params = {}) => {
  try {
    const response = await client.get(
      "/api/v1/report/analytics/savings-deposits",
      { params },
    );
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchSharesIssuedAnalytics = async (params = {}) => {
  try {
    const response = await client.get(
      "/api/v1/report/analytics/shares-issued",
      { params },
    );
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchLoanSummaryAnalytics = async (params = {}) => {
  try {
    const response = await client.get("/api/v1/report/analytics/loan-summary", {
      params,
    });
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchLoanDisbursementsAnalytics = async (params = {}) => {
  try {
    const response = await client.get(
      "/api/v1/report/analytics/loan-disbursements",
      { params },
    );
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchLoanDefaultRateAnalytics = async (params = {}) => {
  try {
    const response = await client.get(
      "/api/v1/report/analytics/loan-default-rate",
      { params },
    );
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchAverageLoanTenureAnalytics = async (params = {}) => {
  try {
    const response = await client.get(
      "/api/v1/report/analytics/average-loan-tenure",
      { params },
    );
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchNplRatioAnalytics = async (year) => {
  try {
    const response = await client.get("/api/v1/report/analytics/npl-ratio", {
      params: { year },
    });
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchAllReportTypes = async () => {
  try {
    const response = await client.get("/api/v1/report/types");
    return response?.data?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const fetchGeneratedReport = async ({
  reportType,
  reportKey,
  startDate,
  endDate,
  page,
  limit,
  exportFormat = "json",
}) => {
  try {
    const payload = {
      reportType,
      reportKey,
      exportFormat,
    };

    // Optional params
    if (startDate) payload.startDate = startDate;
    if (endDate) payload.endDate = endDate;
    if (page) payload.page = page;
    if (limit) payload.limit = limit;

    const response = await client.post("/api/v1/report/generate", payload);

    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const exportReportAsCSV = async ({
  reportType,
  reportKey,
  startDate,
  endDate,
  limit,
}) => {
  try {
    const payload = {
      reportType,
      reportKey,
      exportFormat: "csv",
    };

    if (startDate) payload.startDate = startDate;
    if (endDate) payload.endDate = endDate;

    if (limit) payload.limit = limit;

    const response = await client.post("/api/v1/report/generate", payload, {
      responseType: "blob",
    });

    const contentDisposition = response.headers["content-disposition"];
    const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
    const fileName = fileNameMatch ? fileNameMatch[1] : "report.csv";

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return true;
  } catch (error) {
    console.error("CSV export failed:", error);
    throw error?.response?.data || error;
  }
};

export const exportTableReportAsCSV = async ({
  reportType,
  reportKey,
  startDate,
  endDate,
  page,
  limit,
}) => {
  try {
    const payload = {
      reportType,
      reportKey,
      exportFormat: "csv",
    };

    if (startDate) payload.startDate = startDate;
    if (endDate) payload.endDate = endDate;
    if (page) payload.page = page;
    if (limit) payload.limit = limit;

    const response = await client.post("/api/v1/report/generate", payload, {
      responseType: "blob",
    });

    const contentDisposition = response.headers["content-disposition"];
    const fileNameMatch = contentDisposition?.match(/filename="(.+)"/);
    const fileName = fileNameMatch ? fileNameMatch[1] : "report.csv";

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    return true;
  } catch (error) {
    console.error("CSV export failed:", error);
    throw error?.response?.data || error;
  }
};
